type FixedSizeArray<N extends number> = unknown[] & { length: N };
export const repeat = <N extends number>(count: N): FixedSizeArray<N> =>
	Array.from({ length: count }) as FixedSizeArray<N>;
